import Switch_1 from './switch-1';
import Switch_2 from './switch-2';
import Switch_3 from './switch-3';
import Switch_23 from './switch-23';

/**
 * Switch style registry.
 *
 * The free plugin ships styles 1, 2, 3 and 23. The remaining styles are premium
 * and are registered into this same object by the Ultimate add-on, so their
 * markup is not present in the free plugin's bundle.
 *
 * Exposed on `window.WPDarkModeSwitches` so the add-on can extend it.
 */
const Switches = {
    Switch_1,
    Switch_2,
    Switch_3,
    Switch_23,
};

if (typeof window !== 'undefined') {
    window.WPDarkModeSwitches = Switches;
}

export default Switches;

export {
    Switch_1,
    Switch_2,
    Switch_3,
    Switch_23,
};
